/* Accessibility fixes (WCAG 2.2 AA), 2026-10-13. Loaded with defer from layout/theme.liquid. */
(function () {
  // 2.4.3 Focus order: while the cart drawer is closed its contents (Rebuy recommendations)
  // stayed in the Tab order, invisible, ahead of the header. Make it inert until it opens.
  function syncDrawer(drawer) {
    drawer.inert = !drawer.classList.contains('active');
  }
  document.querySelectorAll('cart-drawer').forEach(function (drawer) {
    syncDrawer(drawer);
    new MutationObserver(function () { syncDrawer(drawer); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'] });
  });

  // Not an ADA fix (also on the old theme): the phone menu drawer's sub-categories sit in
  // <template data-megamenu-template>, which global.js only renders on mouseenter/focusin, wired up at
  // page load. The drawer's content is added later, when it opens, so its sub-category links never
  // appeared. Render any such template as soon as it lands inside the drawer.
  document.querySelectorAll('header-drawer').forEach(function (drawer) {
    function renderTemplates() {
      drawer.querySelectorAll('template[data-megamenu-template]').forEach(function (template) {
        template.parentElement.appendChild(template.content.cloneNode(true));
        template.remove();
      });
    }
    renderTemplates();
    new MutationObserver(renderTemplates).observe(drawer, { childList: true, subtree: true });
  });

  // custom.js lines each mega menu up under its item once, at page load. When that runs before
  // this file's CSS has hidden the submenu toggles, the toggles' width pushes the panels right,
  // and zoom or resize also leaves them misplaced. Line the panel up again each time it opens.
  function placePanel(item) {
    var panel = item.querySelector(':scope > .block__header--megamenu--wrapper.block__header-megamenu-left');
    var list = document.querySelector('.list-menu--inline');
    if (panel && list) panel.style.left = item.offsetLeft - list.offsetLeft + 'px';
  }

  // 2.1.1 Keyboard: the main menu's mega menus opened on mouse hover only.
  // Each item now has a toggle button (snippets/header-dropdown-menu.liquid).
  document.querySelectorAll('.block__header--megamenu-list').forEach(function (item) {
    item.addEventListener('mouseenter', function () { placePanel(item); });
    var toggle = item.querySelector(':scope > .ada-submenu-toggle');
    if (!toggle) return;
    function setOpen(open) {
      if (open) item.dispatchEvent(new Event('mouseenter')); // loads the menu's <template> (global.js) and places it
      item.classList.toggle('ada-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('header-menu-open', open);
    }
    toggle.addEventListener('click', function () {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });
    item.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && item.classList.contains('ada-open')) {
        setOpen(false);
        toggle.focus();
      }
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) setOpen(false);
    });
  });
})();
